(() => {
    const cache = new Map();
  
    async function fetchSizes(productUrl, colorOptionValueId) {
      const cacheKey = `${productUrl}::${colorOptionValueId}`;
      if (cache.has(cacheKey)) return cache.get(cacheKey);
  
      const url = `${productUrl}?section_id=quick-add-sizes&option_values=${encodeURIComponent(colorOptionValueId)}`;
      const html = await fetch(url, { credentials: 'same-origin' }).then(r => r.text());
  
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const frag = doc.querySelector('[data-quick-add-sizes-fragment]');
      const liHtml = frag ? frag.innerHTML : '';
  
      cache.set(cacheKey, liHtml);
      return liHtml;
    }
  
    async function hydrate(ul) {
      if (!ul || ul.dataset.loaded === '1') return;
  
      const productUrl = ul.dataset.productUrl;
      const colorId = ul.dataset.colorOptionValueId;
      if (!productUrl || !colorId) return;
  
      ul.dataset.loaded = '1';
  
      // remove any previous size <li> (keep the heading)
      ul.querySelectorAll('li').forEach(li => li.remove());
  
      const liHtml = await fetchSizes(productUrl, colorId);
      if (liHtml) ul.insertAdjacentHTML('beforeend', liHtml);
    }
  
    function init(root = document) {
      root.querySelectorAll('ul[data-quick-add-sizes]').forEach(ul => {
        // lazy-load when near viewport
        observer.observe(ul);
      });
    }
  
    const observer = new IntersectionObserver(
      entries => entries.forEach(e => e.isIntersecting && hydrate(e.target)),
      { rootMargin: '200px' }
    );
  
    // Handle initial load
    document.addEventListener('DOMContentLoaded', () => init());
  
    // Handle collection grid being replaced by filters (MutationObserver is the most robust)
    const grid = document.getElementById('CollectionProductGrid') || document.body;
    const mo = new MutationObserver(muts => {
      for (const m of muts) {
        m.addedNodes.forEach(node => {
          if (node.nodeType === 1) init(node);
        });
      }
    });
    mo.observe(grid, { childList: true, subtree: true });
  })();
  